import React, { useEffect, useRef } from "react";

import { Link, useLocation } from "react-router-dom";
import translations from "./header-translations"
import { LANGS, languageLink } from "../../languages";

const GlobeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3z" />
  </svg>
);

// Same page in another language. Links stay real links so search engines can follow them. Navigation is
// client-side and keeps the router state, so the quote confirmation page survives the switch.
const LanguageMenu = ({ lang, alternates }) => {
  const location = useLocation();
  const menu = useRef(null);

  useEffect(() => {
    if (menu.current) menu.current.open = false;
  }, [location]);

  useEffect(() => {
    const closeOutside = (e) => {
      if (menu.current && !menu.current.contains(e.target)) menu.current.open = false;
    };
    document.addEventListener("click", closeOutside);
    return () => document.removeEventListener("click", closeOutside);
  }, []);

  return (
    <details className="lang-switch" ref={menu}>
      <summary aria-label={translations[lang].selected.label}>
        <GlobeIcon />
        {lang.toUpperCase()}
      </summary>
      <ul>
        {LANGS.map((code) => (
          <li key={code}>
            <Link
              to={languageLink(code, location, alternates)}
              state={location.state}
              hrefLang={code}
              lang={code}
              aria-current={code === lang ? "true" : undefined}
            >
              {translations[code].selected.label}
            </Link>
          </li>
        ))}
      </ul>
    </details>
  );
};

const Header = (props) => {

  return (
    <div className="site-header d-flex flex-column flex-md-row align-items-center p-3 px-md-4 border-bottom box-shadow">
      <h5 className="my-0 mr-md-auto font-weight-normal">
        <Link to={translations[props.lang].brand.url}>
          <span className="wordmark">Davoyage</span>
        </Link>
      </h5>
      <nav className="my-2 my-md-0 mr-md-3">
        <Link to={translations[props.lang].home.url} className="p-2 text-dark">
          {translations[props.lang].home.label}
        </Link>

        <Link to={translations[props.lang].quote.url} className="p-2 text-dark">
          {translations[props.lang].quote.label}
        </Link>

        <Link to={translations[props.lang].blog.url} className="p-2 text-dark">
          {translations[props.lang].blog.label}
        </Link>
      </nav>
      <a
        className="btn cta"
        tabIndex="1"
        href="tel:+33660265336"
      >
        <svg
          className="svg-inline--fa fa-phone fa-w-16"
          aria-hidden="true"
          data-prefix="fas"
          data-icon="phone"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          data-fa-i2svg=""
        >
          <path
            fill="currentColor"
            d="M493.397 24.615l-104-23.997c-11.314-2.611-22.879 3.252-27.456 13.931l-48 111.997a24 24 0 0 0 6.862 28.029l60.617 49.596c-35.973 76.675-98.938 140.508-177.249 177.248l-49.596-60.616a24 24 0 0 0-28.029-6.862l-111.997 48C3.873 366.516-1.994 378.08.618 389.397l23.997 104C27.109 504.204 36.748 512 48 512c256.087 0 464-207.532 464-464 0-11.176-7.714-20.873-18.603-23.385z"
          ></path>
        </svg>
        <span>&nbsp;&nbsp; {translations[props.lang].phone}</span>
      </a>
      <LanguageMenu lang={props.lang} alternates={props.alternates} />
    </div>
  );
};

export default Header;
